import { isAnyOf } from "@reduxjs/toolkit";
import { startImpersonationSession, stopImpersonationSession } from "@impersonateUser/store/actions";
import { fetchUserTerms } from "@terms/store/thunks/fetchUserTerms";
import { resetAccountFundAccessState } from "@myProfile/store/ducks";
import { fetchUserIFCsThunk } from "@myProfile/store/thunks";
import { GetAppListener } from "@shared/models/redux";
import { LocalStorageKeys } from "@app/constants/localStorage";

export const getImpersonationListener: GetAppListener = (addAppListener) =>
  addAppListener({
    matcher: isAnyOf(startImpersonationSession, stopImpersonationSession),
    effect: (action, { dispatch, getState }) => {
      localStorage.removeItem(LocalStorageKeys.LpcActiveSession);

      // Clear cached account/fund access data when impersonation changes
      // This ensures fresh data is fetched for the new user context
      dispatch(resetAccountFundAccessState());

      dispatch(fetchUserTerms());

      // Fetch IFCs for the active user context so useProfileMenuPermissions
      // can correctly determine My Profile visibility (AC1/AC2)
      let contactId = "";

      if (startImpersonationSession.match(action)) {
        // Starting impersonation: use the impersonated user's sfdcContactId
        contactId = action.payload.sfdcContactId || "";
      } else {
        // Stopping impersonation: use the admin's own sfdcContactId
        const state = getState();

        contactId = state.user.data?.sfdcContactId || "";
      }

      dispatch(fetchUserIFCsThunk(contactId));
    },
  });
